import React, { Component } from "react";

import { CModal, CModalBody, CModalHeader, CModalTitle } from "@coreui/react";
import { connect } from "react-redux";

import QuestionBank from "../QuestionBank";

import "./styles.css";

class QuestionImportModal extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        closeOnBackdrop={false}
        onClose={this.props.modalCloser}
        size="lg w-100 h-100 m-0 p-0 mw-100"
        style={{ width: "100%", height: "100%", borderRadius: "0" }}
      >
        <CModalHeader closeButton>
          <div className="d-inline-flex justify-content-between align-items-center w-100">
            <CModalTitle>Banco de Questões</CModalTitle>
          </div>
        </CModalHeader>
        <CModalBody className="overflow-hidden">
          <QuestionBank
            importQuestion={this.props.questionImporter}
            importQuestions={this.props.questionsImporter}
          />
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps, null)(QuestionImportModal);
